<template lang="pug">
  .toggle-container.mt-1
    span.mr-2 全URL計測
    // 切替ボタンコンポーネント。sync モードで is_active を反映させる
    toggle-button.mt-1(:value="is_active", @change="handleToggleHeatmap($event)", :sync="true")
    // モーダルの定義（BootstrapVue の b-modal を使用）
    b-modal(
      ref="confirmModal"
      id="confirm-toggle-modal"
      title="ヒートマップを全て自動で計測開始しますか？"
      hide-footer
    )
      p 全URL計測を利用することで、現在ヒートマップ一覧に表示されているURLと、
        | 今後追加表示されるURLにおいて、ヒートマップ計測が開始します。
      p ヒートマップ計測するURLを個別で指定する場合は、こちらの機能は利用せず、
        | ヒートマップ一覧に表示されているURLごとに計測を開始してください。
      .row
        .col.text-center
          b-button.btn.btn-success(@click="confirmToggle") 利用する
          b-button.btn.btn-secondary.ml-2(@click="cancelToggle") 利用しない
</template>

<script>
import axios from '../../plugins/axios';
export default {
  name: 'HeatmapToggleBtn',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    showOffMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 初期値は prop から受け取る
      is_active: this.isActive,
    };
  },
  async mounted() {
    // モーダルの表示を設定
    if (this.showOffMessage) {
      this.$toasted.success('全URL計測を停止しました。')
      await sleep(10000)
      this.$toasted.clear()
    }
  },
  methods: {
    // ボタン押下時にモーダルを表示
    handleToggleHeatmap(newValue) {
      this.is_active = !newValue.value;
      // true（オンにする）場合は確認モーダルを表示
      if (newValue.value) {
        this.$refs.confirmModal.show();
      } else {
        // false（オフにする）場合は即座に GET リクエストで遷移
        window.location.href = "/users/heatmaps/update_all_flg";
      }
    },
    // モーダルの「はい」をクリックした際の処理
    async confirmToggle() {
      this.$refs.confirmModal.hide();
      // GETリクエストとして /users/heatmaps/update_all_flg に遷移
      window.location.href = "/users/heatmaps/update_all_flg";
    },
    // モーダルの「いいえ」をクリックした場合、何もせずモーダルを閉じる
    cancelToggle() {
      this.$refs.confirmModal.hide();
    }
  }
};
</script>